import React from 'react';

import { formatDateToDDMMYYYY, formatTimeInMoscow, parseJournalApiDate, useFormatDate } from '../../../../utils';
import * as s from './DatePublished.css';

interface IDateTimePublished {
  /** Дата строкой вв ISO */
  children: string;
  /** Выводить ли текст Обновлено */
  isUpdated?: boolean;
}

/**
 * Дата и время публикации
 */
export const DateTimePublished = ({ children, isUpdated }: IDateTimePublished) => {
  const formatDate = useFormatDate();
  const date = parseJournalApiDate(children);
  const time = formatTimeInMoscow(date);

  return (
    <time className={s['wrapper']} dateTime={date.toISOString()} title={`${formatDate(date)}, ${time}`}>
      {`${isUpdated ? 'Обновлено ' : ''}${formatDateToDDMMYYYY(date)}, ${time}`}
    </time>
  );
};
